import React, { useEffect } from 'react';
import css from './EngagementSection.css';
import { SectionOurPartners } from '../../sectionsForClubs';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';
import config from '../../../../config';

const { userTypeHorseowner } = config;

export default () => {
    const history = useHistory();

    const { role } = parse(history.location.search);
    const locationHash = history.location.hash;

    /**
     * We use # intentionally to prevent the browser from scrolling to the element on page load.
     * We want to scroll to it after a timeout,
     * so that the page is fully loaded and the element is rendered.
     */
    const hashToDetect = '#engagement';

    const shouldScroll = hashToDetect === locationHash;

    useEffect(() => {
        if (!shouldScroll) return;

        setTimeout(() => {
            const element = document.getElementById(hashToDetect);

            if (element) {
                const headerOffset = 70;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            }
        }, 1000);
    }, [shouldScroll]);

    return (
        <>
            <SectionOurPartners
                header={
                    <header className={css.header} id="#engagement">
                        <h2 className={css.subHeading}>Engagement</h2>
                        <p className={css.heading}>Gemeinsam für den Pferdesport von morgen</p>
                        <p className={css.description}>
                            Wir setzen uns für einen fairen und nachhaltigen Pferdesport ein.
                            Deshalb fördern wir gezielt Vereine und Veranstaltungen, die diese Werte
                            stärken. Gleichzeitig profitierst Du als Vereinsmitglied von
                            zusätzlichen Vorteilen wie z. B. kostenlosen Credits.
                        </p>
                    </header>
                }
            />
            <section className={css.root}>
                <header>
                    <h2 className={css.subHeading}>Kostenlos registrieren</h2>
                    <p className={css.heading}>Werde Teil der Community</p>
                    <p className={css.description}>
                        Werde Teil unserer Community und erhalte einen kostenlosen Zugang zu
                        hunderten Pferdemenschen und Pferden mit wenigen Klicks. Leg heute noch los!
                    </p>
                </header>

                <footer className={css.footer}>
                    <Button
                        className={css.subLinkPrimary}
                        onClick={() =>
                            history.push(
                                createResourceLocatorString(
                                    role === userTypeHorseowner
                                        ? 'SignupRider'
                                        : 'SignupHorseowner',
                                    routeConfiguration()
                                )
                            )
                        }
                    >
                        Kostenlos registrieren
                    </Button>
                </footer>
            </section>
        </>
    );
};
